export default __webpack_public_path__ + "static/media/miles-collab-banner.0a9bf2cf.png";